import React from 'react';
import cn from 'classnames';
import { format } from 'date-fns';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { Button } from '@nw/omega-design-system';

import { ChevronLeftArrowIcon } from '../../icons/ChevronLeftArrowIcon';
import { ChevronRightArrowIcon } from '../../icons/ChevronRightArrowIcon';

import { FilterType } from '.';

interface CustomHeaderProps {
  params: ReactDatePickerCustomHeaderProps;
  filters?: Array<FilterType>;
  onClickFilter: (value: string) => void;
  selectedFilterValue?: string;
  headerDisplayFormat?: string;
}

export const CustomHeader = (props: CustomHeaderProps) => {
  const {
    params,
    filters,
    onClickFilter,
    headerDisplayFormat,
    selectedFilterValue
  } = props;
  const {
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  } = params;

  return (
    <div className={cn('flex justify-center mr-4')}>
      {filters && onClickFilter ? (
        <ul className={cn('flex flex-col mr-16px')}>
          {filters.map((eachFilter) => {
            return (
              <li
                key={eachFilter.value}
                className={cn(
                  ' flex mb-8px px-8px py-12px cursor-pointer',
                  `${
                    eachFilter.value === selectedFilterValue ? 'bg-blue-50' : ''
                  }`
                )}
                onClick={() => onClickFilter(eachFilter.value)}
              >
                <p className={cn('text-sm text-blue-gray-700')}>
                  {eachFilter.label}
                </p>
              </li>
            );
          })}
        </ul>
      ) : null}
      <div className={cn('flex items-center')}>
        <Button
          variant="Plain"
          size="Small"
          onClick={decreaseMonth}
          isDisabled={prevMonthButtonDisabled}
          className={cn('navigation-buttons')}
        >
          <ChevronLeftArrowIcon />
        </Button>
        <p
          className={cn(
            'text-sm leading-5 font-semibold mx-4px text-blue-gray-700'
          )}
        >
          {format(date, headerDisplayFormat ?? 'MMMM yyyy')}
        </p>

        <Button
          variant="Plain"
          size="Small"
          onClick={increaseMonth}
          isDisabled={nextMonthButtonDisabled}
          className={cn('navigation-buttons')}
        >
          <ChevronRightArrowIcon />
        </Button>
      </div>
    </div>
  );
};
